var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleDialog',{attrs:{"open":_vm.visible,"text":(_vm.actionMessage + " loan " + _vm.loanRef)},on:{"close":_vm.closeModal,"dialog-decision":function (payload) { return _vm.actOnDecision(payload); }}})}
var staticRenderFns = []

export { render, staticRenderFns }